import { ChevronRight } from "lucide-react";
import breadcrumbStyles from "../../styles/docs/docsBreadcrumb.module.scss";

const DocsBreadcrumb = ({ groupLabel, itemLabel }) => (
  <div className={breadcrumbStyles.bar}>
    <div className={breadcrumbStyles.trail}>
      <span>Docs</span>
      <ChevronRight size={11} className={breadcrumbStyles.separator} />
      {groupLabel && itemLabel && (
        <span className={breadcrumbStyles.segment}>
          <span>{groupLabel}</span>
          <ChevronRight size={11} className={breadcrumbStyles.separator} />
          <span className={breadcrumbStyles.segmentCurrent}>{itemLabel}</span>
        </span>
      )}
    </div>
  </div>
);

export default DocsBreadcrumb;
